import { ComponentsPlatformService } from '@wix/editor-platform-manifest-services';
import { CompRef } from '@wix/document-services-types';
import { hasAnyMeaningfulValue } from '../common/actionValidators/actionVisibilityRules';
import { Meaningfulness } from '../common/meaningfulnessPredicates';
import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import {
  PADDING_CSS_PROPERTY_TYPES,
  GAP_CSS_PROPERTY_TYPES,
} from '../constants';

import { EditorPointer } from '@wix/editor-document-logic-api';

/**
 * Spacing action validator
 *
 * Rules:
 * - Show if any element has padding or gap properties (including 0px)
 * - 0px is meaningful for spacing (explicit no spacing)
 *
 * @param componentsAPI - Components platform service
 * @param editorPointers - Selected editor pointers
 * @returns true if spacing action should be shown
 */
export const createSpacingValidator = () => {
  return (
    componentsAPI: ComponentsPlatformService,
    editorPointers: EditorPointer<CompRef>[],
  ): boolean => {
    const rootContexts = editorPointers.map((editorPointer) =>
      componentsAPI.buildManifestAPI({ editorPointers: [editorPointer] }),
    );

    // Check both padding and gap properties
    const spacingProperties = new Set([
      ...PADDING_CSS_PROPERTY_TYPES,
      ...GAP_CSS_PROPERTY_TYPES,
    ]);

    for (const rootContext of rootContexts) {
      if (
        hasAnyMeaningfulValue(
          rootContext,
          spacingProperties,
          Meaningfulness.meaningCheck(StylesDerivedNativeActions.spacingStyles),
        )
      ) {
        return true;
      }
    }

    return false;
  };
};
